import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import { makeLogger } from '../../../../logger/logger';
import {PassFacetStrategyService} from '../../PassFacetStrategyService';
import type {IPassFacetStrategyData} from '../../types/pass-facet-srategy-data.type';

const { info } = makeLogger({
  pathToCurrentFile:
    'components/strategies/services/pass-facet-service/pass-facet-fallback.service.ts',
  loggersList: ['debug'],
});

@Service({ id: 'passFacetFallbackStrategyService' })
export class PassFacetFallbackConfigurationBuilder extends StrategyBuilder<PassFacetStrategyService> {
  private ppp: null|FallbackPassFacetInfoStrategyService = null;
  build(
    details: IPassFacetStrategyData
  ): PassFacetStrategyService {
      if(this.ppp == null)
        this.ppp = new FallbackPassFacetInfoStrategyService(details);
      return this.ppp;
  }
}

export class FallbackPassFacetInfoStrategyService extends PassFacetStrategyService {
  details;

  constructor(details: IPassFacetStrategyData) {
      super();
      this.details = details;
  }

  public haveFacetConditionsChildrenNames(){
      info('Fallback - no facet conditions children names to set');
  }
  public register(){
      info('Fallback - nothing to register');
  }

  public resetFacetConditionsChildrenNames(){
      info('Fallback - nothing to reset');
  }

}
